import viewTypes from './ViewType.constants';

const fields = {
	Template : 'Template',
	ReadyForApproval : 'Ready for Approval',
	ContractReleaseDate : 'Contract Release Date',
	ContractEndDate : 'Contract End Date',
	TeamEmail : 'Team Email',
	MarkingMethod: 'Marking Method',
	E_MarkingStartDate: 'E-Marking Start Date',
	E_MarkingEndDate: 'E-Marking End Date'
};

const getUpdateFields = (isMarker = false, updateViewType = '') => {
	let updateFields = [
		fields.Template,
		fields.ReadyForApproval,
		fields.ContractReleaseDate,
		fields.ContractEndDate,
		fields.TeamEmail
	];

	if(isMarker) {
		if(updateViewType == viewTypes.MarkerAppointmentManagement) {
			updateFields = [...updateFields, fields.MarkingMethod];
		}
		else if(updateViewType == viewTypes.ScriptDates) {
			updateFields = [fields.E_MarkingStartDate, fields.E_MarkingEndDate];
		}
	}
	
	updateFields.sort();

	return updateFields;
};

export default fields;
export { getUpdateFields };